/* ============================================================
   KLIDNO — Shopify theme behavior
   Cart runs on Shopify's AJAX Cart API; the cart drawer + cart
   page re-render through the Section Rendering API so all money
   formatting stays in Liquid.
   ============================================================ */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var CFG = window.KLIDNO_CONFIG || {};

  /* ---------------- Analytics (optional) ---------------- */
  function initAnalytics() {
    if (CFG.pixelId && window.fbq == null) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
        t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      window.fbq("init", CFG.pixelId); window.fbq("track", "PageView");
    }
    if (CFG.klaviyoId && window.klaviyo == null) {
      var k = document.createElement("script"); k.async = true;
      k.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=" + CFG.klaviyoId;
      document.head.appendChild(k); window._klOnsite = window._klOnsite || [];
    }
  }
  window.track = function (event, data) {
    data = data || {};
    if (window.fbq) window.fbq("track", event, data);
    if (window.klaviyo) { try { window.klaviyo.track(event, data); } catch (e) {} }
    if (!window.fbq && !window.klaviyo) console.info("[track]", event, data);
  };

  /* ---------------- Overlay + focus trap ---------------- */
  var overlayCb = null, lastFocused = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
  function ensureOverlay() {
    var o = $("#overlay");
    if (!o) { o = document.createElement("div"); o.className = "overlay"; o.id = "overlay"; document.body.appendChild(o); o.addEventListener("click", function () { if (overlayCb) overlayCb(); }); }
    return o;
  }
  function showOverlay(cb) { var o = ensureOverlay(); overlayCb = cb; o.classList.add("show"); }
  function hideOverlay() { var o = $("#overlay"); if (o) o.classList.remove("show"); overlayCb = null; }
  function visibleFocusable(c) { return $$(FOCUSABLE, c).filter(function (el) { return el.offsetParent !== null; }); }
  function focusInto(c) {
    lastFocused = document.activeElement;
    var f = visibleFocusable(c); (f[0] || c).focus();
    c.__trap = function (e) {
      if (e.key !== "Tab") return;
      var els = visibleFocusable(c); if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    c.addEventListener("keydown", c.__trap);
  }
  function releaseFocus(c) {
    if (c && c.__trap) { c.removeEventListener("keydown", c.__trap); c.__trap = null; }
    if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (e) {} }
    lastFocused = null;
  }

  /* ---------------- Toast ---------------- */
  var toastT;
  function showToast(msg) {
    var t = $("#toast");
    if (!t) { t = document.createElement("div"); t.className = "toast"; t.id = "toast"; document.body.appendChild(t); }
    t.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12.5l4.5 4.5L19 7"/></svg><span>' + msg + "</span>";
    t.classList.add("show"); clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }
  window.showToast = showToast;

  /* ---------------- Cart (Shopify AJAX) ---------------- */
  function updateCount(n) {
    var el = $("#cartCount"); if (!el) return;
    el.textContent = n; el.hidden = n === 0;
  }
  function refreshDrawer() {
    return fetch(ROOT + "?sections=cart-drawer", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data["cart-drawer"]; if (!html) return;
        var tmp = document.createElement("div"); tmp.innerHTML = html;
        var fresh = tmp.querySelector("#cartDrawerInner");
        var current = $("#cartDrawerInner");
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          updateCount(parseInt(fresh.getAttribute("data-cart-count"), 10) || 0);
        }
      });
  }
  function refreshAfterChange() {
    return refreshDrawer().then(function () {
      // The full cart page renders totals server-side; reload it to stay in sync.
      if (document.getElementById("CartForm")) window.location.reload();
    });
  }
  function cartAdd(form) {
    var body = new FormData(form);
    return fetch(ROOT + "cart/add.js", { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest" }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        track("AddToCart", { content_name: item.product_title, value: (item.final_price || 0) / 100, currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active });
        return refreshDrawer();
      })
      .then(function () { showToast(form.getAttribute("data-added-text") || "Přidáno do košíku"); openCart(); })
      .catch(function () { showToast("Něco se nepovedlo, zkuste to znovu."); });
  }
  function cartChange(key, qty) {
    return fetch(ROOT + "cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshAfterChange(); });
  }
  window.klidnoCartChange = cartChange;

  function openCart() { var d = $("#cartDrawer"); if (!d) return; d.classList.add("show"); showOverlay(closeCart); focusInto(d); track("ViewCart"); }
  function closeCart() { var d = $("#cartDrawer"); if (d && d.classList.contains("show")) { d.classList.remove("show"); releaseFocus(d); } hideOverlay(); }
  window.openCart = openCart;

  function bindCartUI() {
    var openBtn = $("#openCart"); if (openBtn) openBtn.addEventListener("click", openCart);
    // Delegated handlers cover drawer + cart page, survive re-renders.
    document.addEventListener("click", function (e) {
      var close = e.target.closest && e.target.closest("#closeCart"); if (close) { closeCart(); return; }
      var rm = e.target.closest && e.target.closest("[data-key].cart-item__rm, .cart-item__rm[data-key]");
      if (rm) { e.preventDefault(); cartChange(rm.getAttribute("data-key"), 0); return; }
      var inc = e.target.closest && e.target.closest(".cart-inc");
      if (inc) { stepQty(inc.getAttribute("data-key"), 1); return; }
      var dec = e.target.closest && e.target.closest(".cart-dec");
      if (dec) { stepQty(dec.getAttribute("data-key"), -1); return; }
    });
    document.addEventListener("change", function (e) {
      var q = e.target.closest && e.target.closest(".cart-qty");
      if (q) cartChange(q.getAttribute("data-key"), Math.max(0, parseInt(q.value, 10) || 0));
    });
    document.addEventListener("submit", function (e) {
      var f = e.target;
      if (f.matches('form[action$="/cart/add"], form.upsell-form, form[data-cart-add]')) { e.preventDefault(); cartAdd(f); }
    });
  }
  function stepQty(key, delta) {
    var input = $('.cart-qty[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    var cur = input ? parseInt(input.value, 10) || 1 : 1;
    cartChange(key, Math.max(0, cur + delta));
  }

  /* ---------------- Mobile menu ---------------- */
  function initMenu() {
    var burger = $("#burger"), nav = $("#mainnav");
    if (!burger || !nav) return;
    function close() {
      nav.classList.remove("open");
      burger.setAttribute("aria-expanded", "false");
      document.body.classList.remove("nav-open");
      hideOverlay();
    }
    function open() {
      nav.classList.add("open");
      burger.setAttribute("aria-expanded", "true");
      document.body.classList.add("nav-open");
      showOverlay(close);
    }
    burger.addEventListener("click", function () {
      if (nav.classList.contains("open")) close(); else open();
    });
    var closeBtn = $("#navClose", nav);
    if (closeBtn) closeBtn.addEventListener("click", close);
    // Close when a nav link is tapped
    nav.addEventListener("click", function (e) {
      if (e.target.closest("a")) close();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* ---------------- FAQ accordion ---------------- */
  function initFaq() {
    $$(".acc").forEach(function (acc) {
      if (acc.dataset.bound) return; acc.dataset.bound = "1";
      var q = $(".acc__q", acc), a = $(".acc__a", acc);
      if (!q || !a) return;
      q.setAttribute("aria-expanded", "false");
      q.addEventListener("click", function () {
        var open = acc.classList.toggle("open");
        q.setAttribute("aria-expanded", open);
        a.style.maxHeight = open ? a.scrollHeight + "px" : 0;
      });
    });
  }

  /* ---------------- Product gallery (thumbs + zoom) ---------------- */
  function initGallery() {
    var main = $(".gallery__main");
    if (!main || main.dataset.bound) return; main.dataset.bound = "1";
    var mainImg = $(".gallery__main img");
    $$(".gallery__thumbs button").forEach(function (b) {
      b.addEventListener("click", function () {
        $$(".gallery__thumbs button").forEach(function (x) { x.classList.remove("active"); });
        b.classList.add("active");
        var src = b.getAttribute("data-src");
        if (mainImg && src) mainImg.src = src;
      });
    });
    main.addEventListener("click", function () { main.classList.toggle("zoom"); });
    main.addEventListener("mousemove", function (e) {
      if (!main.classList.contains("zoom")) return;
      var r = main.getBoundingClientRect();
      var target = mainImg || $(".ph", main);
      if (target) target.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + "% " + ((e.clientY - r.top) / r.height) * 100 + "%";
    });
  }

  /* ---------------- Countdown ---------------- */
  function initCountdown() {
    $$("[data-countdown]").forEach(function (el) {
      if (el.dataset.bound) return; el.dataset.bound = "1";
      var target = new Date(); target.setHours(23, 59, 59, 0);
      var slot = el.querySelector(".countdown__t"); if (!slot) return;
      function tick() {
        var diff = Math.max(0, target - new Date());
        var h = String(Math.floor(diff / 3.6e6)).padStart(2, "0");
        var m = String(Math.floor((diff % 3.6e6) / 6e4)).padStart(2, "0");
        var s = String(Math.floor((diff % 6e4) / 1e3)).padStart(2, "0");
        slot.innerHTML = "<span>" + h + "</span>:<span>" + m + "</span>:<span>" + s + "</span>";
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------------- Sticky add-to-cart ---------------- */
  function initStickyBuy() {
    var bar = $("#stickyBuy"), anchor = $("#buyAnchor");
    if (!bar || !anchor || bar.dataset.bound) return; bar.dataset.bound = "1";
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal() {
    var els = $$(".reveal"); if (!els.length) return;
    if (matchMedia("(prefers-reduced-motion:reduce)").matches) { els.forEach(function (e) { e.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- Collection filters + sort ---------------- */
  function initFilters() {
    var grid = $("#catGrid"); if (!grid) return;
    var cards = $$("[data-card]", grid);
    var toggle = $("#filterToggle"), panel = $(".filters");
    if (toggle) toggle.addEventListener("click", function () { panel.classList.toggle("open"); });
    function apply() {
      var active = {};
      $$(".filter-opt input:checked").forEach(function (c) { (active[c.name] = active[c.name] || []).push(c.value); });
      var shown = 0;
      cards.forEach(function (card) {
        var ok = true;
        for (var k in active) {
          var vals = (card.dataset[k] || "").split("|");
          if (!active[k].some(function (v) { return vals.indexOf(v) !== -1; })) ok = false;
        }
        card.style.display = ok ? "" : "none"; if (ok) shown++;
      });
      var cnt = $("#catCount"); if (cnt) cnt.textContent = shown;
    }
    $$(".filter-opt input").forEach(function (c) { c.addEventListener("change", apply); });
    var sort = $("#catSort");
    if (sort) sort.addEventListener("change", function () {
      var all = cards.slice();
      all.sort(function (a, b) {
        var pa = +a.dataset.price, pb = +b.dataset.price, ra = +a.dataset.rating, rb = +b.dataset.rating;
        if (sort.value === "price-asc") return pa - pb;
        if (sort.value === "price-desc") return pb - pa;
        if (sort.value === "rating") return rb - ra;
        return 0;
      });
      all.forEach(function (c) { grid.appendChild(c); });
    });
  }

  /* ---------------- Discount + exit-intent popups ---------------- */
  function buildModal(id, html) {
    var m = document.createElement("div");
    m.className = "modal"; m.id = id;
    m.setAttribute("role", "dialog"); m.setAttribute("aria-modal", "true");
    m.setAttribute("aria-label", "Nabídka Klidno"); m.tabIndex = -1;
    m.innerHTML = html; document.body.appendChild(m); return m;
  }
  function showModal(m) { m.classList.add("show"); showOverlay(function () { hideModal(m); }); focusInto(m); }
  function hideModal(m) { if (!m.classList.contains("show")) return; m.classList.remove("show"); releaseFocus(m); hideOverlay(); }
  function anyModalOpen() { return $$(".modal.show").length > 0 || ($("#cartDrawer") && $("#cartDrawer").classList.contains("show")); }
  function bindModal(m) { $$("[data-close]", m).forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); hideModal(m); }); }); }
  var ICON_MOON = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M20 13A8 8 0 1 1 11 4a6 6 0 0 0 9 9Z"/></svg>';
  var ICON_WAVE = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M2 12c2.5-4 5-4 7.5 0s5 4 7.5 0 5-4 5-4"/><path d="M2 17c2.5-4 5-4 7.5 0s5 4 7.5 0 5-4 5-4" opacity=".5"/></svg>';
  var ICON_X = '<svg width="20" height="20" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" fill="none"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_CHECK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';

  function initPopups() {
    if (document.body.dataset.noPopups === "true") return;
    if (CFG.popupsEnabled === false) return;
    var code = CFG.discountCode || "KLID10";
    if (!sessionStorage.getItem("klidno_discount_seen")) {
      var m = buildModal("discountModal",
        '<div class="modal__media">' + ICON_MOON +
          '<h3 style="margin-top:.6rem">Sleva 10 % na první noc</h3>' +
          '<p style="color:#C7CAE3">Přihlaste se k odběru a získejte kód na první nákup. Plus tipy pro lepší spánek.</p></div>' +
        '<div class="modal__body"><button class="modal__close" data-close aria-label="Zavřít">' + ICON_X + '</button>' +
          '<form class="news__form" data-discount><input type="email" required placeholder="vas@email.cz" aria-label="E-mail">' +
          '<button class="btn btn--primary" type="submit">Získat slevu</button></form>' +
          '<a href="#" class="modal__decline" data-close>Teď ne, díky</a></div>');
      bindModal(m);
      setTimeout(function () {
        if (!sessionStorage.getItem("klidno_discount_seen") && !anyModalOpen()) { showModal(m); sessionStorage.setItem("klidno_discount_seen", "1"); }
      }, 8000);
      m.addEventListener("submit", function (e) {
        if (!e.target.matches("[data-discount]")) return;
        e.preventDefault();
        var email = e.target.querySelector("input").value;
        if (window.klaviyo) { try { window.klaviyo.identify({ $email: email }); } catch (x) {} }
        track("Subscribe", { source: "popup" });
        e.target.innerHTML = '<p style="color:var(--ok);font-weight:600;margin:0">' + ICON_CHECK + ' Hotovo! Kód <strong>' + code + '</strong> je ve vaší schránce.</p>';
      });
    }
    if (!sessionStorage.getItem("klidno_exit_seen")) {
      var ex = buildModal("exitModal",
        '<div class="modal__media" style="background:radial-gradient(120% 120% at 70% 10%,#3a3566,#1c1a33)">' + ICON_WAVE +
          '<h3 style="margin-top:.6rem">Ještě neodcházejte do bdělé noci</h3>' +
          '<p style="color:#C7CAE3">Vyzkoušejte Klidno 60 nocí. Když nebudete spát lépe, vrátíme peníze.</p></div>' +
        '<div class="modal__body"><button class="modal__close" data-close aria-label="Zavřít">' + ICON_X + '</button>' +
          '<a href="' + (CFG.exitUrl || ROOT) + '" class="btn btn--primary btn--block">Prohlédnout zátěžové deky</a>' +
          '<a href="#" class="modal__decline" data-close>Pokračovat v prohlížení</a></div>');
      bindModal(ex);
      var onLeave = function (e) {
        if (e.clientY <= 0 && !sessionStorage.getItem("klidno_exit_seen") && !anyModalOpen()) {
          showModal(ex); sessionStorage.setItem("klidno_exit_seen", "1"); document.removeEventListener("mouseout", onLeave);
        }
      };
      setTimeout(function () { document.addEventListener("mouseout", onLeave); }, 4000);
    }
  }

  /* ---------------- Cookie consent ---------------- */
  function buildCookieBanner() {
    var KEY = "klidno_consent";
    var consent = localStorage.getItem(KEY);
    if (consent === "all") { initAnalytics(); return; }
    if (consent === "necessary") return;
    var el = document.createElement("div");
    el.className = "cookie"; el.id = "cookieBanner"; el.setAttribute("role", "dialog"); el.setAttribute("aria-label", "Souhlas s cookies");
    el.innerHTML =
      '<div class="cookie__text"><b>Používáme cookies</b>' +
        '<p>Nezbytné cookies potřebujeme k chodu e-shopu. S vaším souhlasem použijeme i analytické a marketingové cookies. Více v ' +
        '<a href="' + (CFG.privacyUrl || (ROOT + "policies/privacy-policy")) + '">zásadách ochrany údajů</a>.</p></div>' +
      '<div class="cookie__btns">' +
        '<button class="btn btn--sm btn--ghost" data-consent="necessary" style="border-color:rgba(20,22,42,.2);color:var(--midnight)">Jen nezbytné</button>' +
        '<button class="btn btn--sm btn--primary" data-consent="all">Přijmout vše</button></div>';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add("show"); });
    el.addEventListener("click", function (e) {
      var b = e.target.closest("[data-consent]"); if (!b) return;
      var choice = b.dataset.consent;
      localStorage.setItem(KEY, choice);
      if (window.Shopify && window.Shopify.customerPrivacy) {
        try { window.Shopify.customerPrivacy.setTrackingConsent(choice === "all", function () {}); } catch (x) {}
      }
      el.classList.remove("show"); setTimeout(function () { el.remove(); }, 300);
      if (choice === "all") initAnalytics();
    });
  }

  /* ---------------- Init ---------------- */
  function init() {
    buildCookieBanner();
    bindCartUI();
    initMenu();
    initFaq();
    initGallery();
    initCountdown();
    initStickyBuy();
    initReveal();
    initFilters();
    initPopups();
    window.klidnoRefresh = function () { initFaq(); initGallery(); initCountdown(); initStickyBuy(); initReveal(); };
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { $$(".modal.show").forEach(function (m) { hideModal(m); }); closeCart(); }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
